/* Preview is development-theme only and never sends moderation writes. */
document.addEventListener('alpine:init', () => {
  const numeric = value => String(value || '').split('/').pop();
  // Liquid article handles include the blog; API handles do not.
  const bareHandle = (blog, value) => {
    const handle = String(value || '').trim();
    return handle.startsWith(blog + '/') ? handle.slice(blog.length + 1) : handle;
  };
  const contentRef = post => ({...post,
    handle:bareHandle(post.blog,post.handle),
    topic_handle:bareHandle(post.topic_blog,post.topic_handle)
  });
  Alpine.store('moderation', {
    enabled:false, controls:false, preview:false, moderator:false, mode:false, panel:false, customer:'',
    states:{}, catalog:{}, reports:[], removed:[], audit:[], loading:false, busy:false, error:'',
    dialog:null, reason:'', epoch:0, timer:null, pages:{reports:0,removed:0,audit:0}, pagination:{},
    init() {
      const root=document.querySelector('[data-moderation-enabled]');
      if(root?.dataset.cfAuth !== '1') return;
      this.customer=numeric(root.dataset.customerId);
      this.preview=root.dataset.moderationPreview === 'true' && root.dataset.moderationEnabled !== 'true';
      this.enabled=this.preview || root.dataset.moderationEnabled === 'true';
      if(!this.enabled) return;
      this.controls=this.preview;
      if(this.preview) this.moderator=root.dataset.moderatorPreview === 'true';
      else void this.refresh();
      if(!this.bound) {
        this.bound=true;
        window.addEventListener('modl-auth-lost',()=>this.clear());
        window.addEventListener('pagehide',()=>this.clear());
        window.addEventListener('pageshow',event=>{if(event.persisted)this.init();});
        window.addEventListener('modl-preview-report',event=>{
          if(this.preview && this.enabled && !this.reports.some(row=>row.id===event.detail.id))this.reports.unshift(event.detail);
        });
      }
    },
    clear() {
      this.epoch++; clearTimeout(this.timer); this.enabled=false; this.controls=false; this.moderator=false; this.mode=false; this.panel=false;
      this.pages={reports:0,removed:0,audit:0}; this.pagination={};
      this.states={}; this.catalog={}; this.reports=[]; this.removed=[]; this.audit=[]; this.busy=false; this.loading=false; this.closeDialog();
    },
    key(post) { return post.blog+'/'+bareHandle(post.blog,post.handle); },
    register(post) {
      post=contentRef(post);
      if(!post.blog || !post.handle)return;
      this.catalog[this.key(post)]={...post,owner:numeric(post.owner)};
      if(this.preview && post.kind!=='topic' && this.hidden(post.topic_blog,post.topic_handle))this.states[this.key(post)]={...post,state:this.states[this.key(post)]?.state||'visible',thread_id:post.topic_blog+'/'+post.topic_handle};
    },
    stub(blog,handle) {
      const row=this.status(blog,handle); if(!row || row.kind==='topic' || row.thread_id)return null;
      return {id:row.id,handle,title:'Comment',author:'Member',author_id:row.owner,publishedAt:row.published_at,body:'<p>'+this.placeholder(blog,handle)+'</p>',
        metafields:{author_id:row.owner,comments:row.comments || [],comment_index:row.comment_index},_commentIndex:row.comment_index};
    },
    contentVisible(item,blog) {
      const handle=item.comment_handle || item.article_handle || item.handle;
      return !this.hidden(blog || item.blog_handle || item.blogHandle,handle) && !this.hidden(item.parent_blog_handle,item.parent_article_handle);
    },
    status(blog,handle) { return this.states[this.key({blog,handle})]; },
    hidden(blog,handle) { const s=this.status(blog,handle); return !!s && (s.state!=='visible' || !!s.thread_id || !!s.pending); },
    // A deleted parent remains only to give its visible replies context.
    commentVisible(comment) {
      if (this.status('cs-comments', comment.handle)?.state !== 'deleted') return true;
      return (comment.replies || []).some(reply => !this.hidden('cs-comments', reply.handle));
    },
    placeholder(blog,handle) { return this.status(blog,handle)?.state==='deleted' ? 'Comment deleted.' : 'Comment hidden.'; },
    own(post) { return this.enabled && this.controls && !!this.customer && numeric(post.owner)===this.customer; },
    async api(path,body) {
      const response=await window.ModlCommunityAPI.request('/api/moderation'+path,body ? {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)} : {});
      const data=await response.json().catch(()=>({}));
      if(!response.ok) throw Error(data.error || 'Moderation is not connected yet. Please try again.');
      return data;
    },
    async refresh() {
      if(!this.enabled || this.preview || this.loading || this.busy) return;
      const epoch=this.epoch; this.loading=true; clearTimeout(this.timer);
      try {
        const session=await this.api('/session');
        if(epoch!==this.epoch) return;
        this.controls=session.controls === true; this.moderator=session.moderator; if(!this.moderator) { this.mode=false; this.panel=false; this.reports=[]; this.removed=[]; this.audit=[]; }
        const states={}; let cursor='';
        do { const data=await this.api('/state'+(cursor?'?cursor='+encodeURIComponent(cursor):''));
          if(epoch!==this.epoch) return;
          data.items.forEach(row=>{states[this.key(row)]=contentRef(row);}); cursor=data.next_cursor;
        } while(cursor);
        const stateChanged=JSON.stringify(this.states)!==JSON.stringify(states);
        this.states=states;
        if(this.panel && this.moderator) {
          const query=new URLSearchParams(Object.entries(this.pages).map(([section,page])=>[section+'_page',page]));
          const data=await this.api('/panel?'+query); if(epoch!==this.epoch)return;
          for(const section of ['reports','removed','audit']) {
            this[section]=data[section]; this.pages[section]=data.pagination[section].page;
          }
          this.pagination=data.pagination;
        }
        if(stateChanged)window.dispatchEvent(new CustomEvent('modl-moderation-state'));
        if(!this.dialog)this.error='';
        return true;
      } catch(e) { if(epoch===this.epoch)this.error=e.message; }
      finally { if(epoch===this.epoch) {this.loading=false;this.timer=setTimeout(()=>this.refresh(),15000);} }
    },
    openReportCount() { return this.preview ? this.reports.length : (this.pagination.reports?.total ?? 0); },
    pageCount(section) {
      return this.preview ? Math.max(1,Math.ceil(this[section].length/50)) : (this.pagination[section]?.total_pages || 1);
    },
    pageNumber(section) { return Math.min(this.pages[section],this.pageCount(section)-1); },
    pageRows(section) {
      const start=this.pageNumber(section)*50;
      return this.preview ? this[section].slice(start,start+50) : this[section];
    },
    async changePage(section,direction) {
      if(!this.moderator || this.loading || this.busy || !Object.hasOwn(this.pages,section))return;
      const previous=this.pageNumber(section),next=previous+direction,epoch=this.epoch;
      if(next<0 || next>=this.pageCount(section))return;
      this.pages[section]=next;
      if(!this.preview && !await this.refresh()) {
        if(epoch===this.epoch)this.pages[section]=previous;
        return;
      }
      document.getElementById('modl-moderation-'+section)?.scrollIntoView?.({block:'start'});
    },
    openPanel() { if(!this.moderator)return;this.panel=!this.panel;if(this.panel)void this.refresh(); },
    request(action,post) {
      if(this.busy || !this.enabled || !this.controls)return;
      if(action==='delete' && !this.own(post))return;
      if(['hide','restore','dismiss'].includes(action) && !this.moderator)return;
      this.dialog={action,post:contentRef(post)};this.reason='';this.error='';
      document.getElementById('modl-moderation-confirm')?.showModal();
    },
    closeDialog() { document.getElementById('modl-moderation-confirm')?.close();this.dialog=null;this.reason=''; },
    dialogTitle() { const a=this.dialog?.action;return a==='report'?'Report this content':a==='restore'?'Restore this content?':a==='dismiss'?'Dismiss this report?':a==='delete'?'Delete your '+this.dialog.post.kind+'?':'Hide this '+(this.dialog?.post.kind || 'content')+'?'; },
    async confirm() {
      if(!this.dialog || this.busy)return;
      const {action,post}=this.dialog,epoch=this.epoch;
      if(action==='report' && !this.reason.trim())return;
      this.busy=true;this.error='';
      try {
        if(this.preview) this.applyPreview(action,post,this.reason.trim());
        else await this.api(action==='report'?'/reports':action==='dismiss'?'/reports/resolve':'/content',{
          blog:post.blog,handle:post.handle,action,reason:this.reason.trim(),report_id:post.id,report_type:post.type
        });
        if(epoch!==this.epoch)return;
        this.closeDialog();
        window.dispatchEvent(new CustomEvent('modl-moderation-changed',{detail:{action,post,preview:this.preview}}));
        if(!this.preview) { this.busy=false; await this.refresh(); }
      } catch(e) {if(epoch===this.epoch)this.error=e.message;}
      finally {if(epoch===this.epoch)this.busy=false;}
    },
    applyPreview(action,post,reason) {
      const key=this.key(post),now=new Date().toISOString();
      if(action==='report') { if(!this.reports.some(r=>r.blog===post.blog&&r.handle===post.handle))this.reports.unshift({...post,id:'preview-'+key,type:'forum',reason,created_at:now});return; }
      if(action==='dismiss') {this.reports=this.reports.filter(r=>r.id!==post.id);return;}
      let state=this.states[key] || {...post,state:'visible',thread_id:null,pending:false};
      if(action==='restore')state={...state,state:'visible'};
      else state={...state,state:action==='delete'?'deleted':'hidden'};
      this.states[key]=state;
      if(post.kind==='topic') for(const [k,item] of Object.entries(this.catalog)) {
        if(item.topic_blog===post.blog && item.topic_handle===post.handle && item.kind!=='topic')
          this.states[k]={...item,...this.states[k],state:this.states[k]?.state || 'visible',thread_id:action==='restore'?null:key};
      }
      this.removed=Object.values(this.states).filter(s=>s.state!=='visible');
      this.audit.unshift({action,actor:this.customer,title:post.title || post.kind,created_at:now});
      if(action!=='restore')this.reports=this.reports.filter(r=>r.blog!==post.blog||r.handle!==post.handle);
    }
  });
  Alpine.data('ForumContentActions', post => ({
    post:contentRef(post),
    init(){this.$store.moderation.register(this.post);},
    get removed(){return this.$store.moderation.hidden(this.post.blog,this.post.handle);},
    get own(){return this.$store.moderation.own(this.post);}
  }));
});
